import { KibsiClient } from './base';
export class HistoryKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'history');
    }
    itemAggregates(deploymentId, startTime, endTime, interval, requestConfig) {
        return this.get(`/deployments/${deploymentId}/item-aggregates`, {
            ...requestConfig,
            params: { startTime, endTime, interval },
        });
    }
    itemCounts(deploymentId, startTime, endTime, requestConfig) {
        return this.get(`/deployments/${deploymentId}/item-counts`, {
            ...requestConfig,
            params: { startTime, endTime },
        });
    }
    heuristicCounts(deploymentId, startTime, endTime, requestConfig) {
        return this.get(`/deployments/${deploymentId}/heuristic-counts`, {
            ...requestConfig,
            params: { startTime, endTime },
        });
    }
    distinctItems(deploymentId, startTime, endTime, interval, queryRequest, requestConfig) {
        return this.post(`/deployments/${deploymentId}/distinct-items`, queryRequest, {
            ...requestConfig,
            params: { startTime, endTime, interval },
        });
    }
    counterAggregates(deploymentId, itemType, nameField, counterField, startTime, endTime, interval, requestConfig) {
        return this.get(`/deployments/${deploymentId}/counter-aggregates`, {
            ...requestConfig,
            params: { itemType, nameField, counterField, startTime, endTime, interval },
        });
    }
    snapshot(deploymentId, snapshotTime, requestConfig) {
        return this.get(`/deployments/${deploymentId}/snapshot`, {
            ...requestConfig,
            params: { snapshotTime },
        });
    }
    snapshotInterval(deploymentId, startTime, endTime, requestConfig) {
        return this.get(`/deployments/${deploymentId}/snapshot-interval`, {
            ...requestConfig,
            params: { startTime, endTime },
        });
    }
    itemDetails(deploymentId, startTime, endTime, id, requestConfig) {
        return this.get(`/deployments/${deploymentId}/items/${id}/details`, {
            ...requestConfig,
            params: { startTime, endTime },
        });
    }
    floorPlanHeatmap(floorPlanId, startTime, endTime, queryRequest, requestConfig, imageType = 'floorPlan') {
        return this.post(`/floor-plans/${floorPlanId}/heatmap`, queryRequest, {
            ...requestConfig,
            params: { startTime, endTime, imageType },
        });
    }
    heatmapGridEvents(floorPlanId, startTime, endTime, queryRequest, requestConfig, imageType = 'floorPlan') {
        return this.post(`/floor-plans/${floorPlanId}/grid-events`, queryRequest, {
            ...requestConfig,
            params: { startTime, endTime, imageType },
        });
    }
    itemPath(floorPlanId, startTime, endTime, queryRequest, requestConfig, imageType = 'floorPlan') {
        return this.post(`/floor-plans/${floorPlanId}/item-path`, queryRequest, {
            ...requestConfig,
            params: { startTime, endTime, imageType },
        });
    }
}
//# sourceMappingURL=history.js.map